/* EpicPlacess accessibility patch (Sep 2026).
   Lighthouse flags <iframe>s without a title and links without an accessible name. This covers markup the theme
   does not own: app embeds, Shopify's Follow on Shop / chat iframes, and image-only links whose image has no alt. */
(function () {
  'use strict';
  if (!document.querySelectorAll || !window.MutationObserver) return;

  function humanize(str) {
    str = String(str || '').replace(/\.[a-z0-9]+$/i, '').replace(/[-_+]+/g, ' ').replace(/\s+/g, ' ').trim();
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
  }

  function hostOf(url) {
    try { return new URL(url, location.href).hostname.replace(/^www\./, ''); } catch (e) { return ''; }
  }

  function labelFromHref(href) {
    try {
      var u = new URL(href, location.href);
      var seg = u.pathname.split('/').filter(Boolean).pop();
      if (seg && !/^\d+$/.test(seg)) return humanize(decodeURIComponent(seg));
      return humanize(u.hostname.replace(/^www\./, '').split('.')[0]);
    } catch (e) { return ''; }
  }

  function titleFrame(f) {
    if (f.hasAttribute('title')) return;
    var host = hostOf(f.getAttribute('src') || '');
    var name = f.getAttribute('aria-label') || f.getAttribute('name') || '';
    f.setAttribute('title', name ? humanize(name) : (host ? 'Embedded content from ' + host : 'Embedded content'));
  }

  function hasName(a) {
    if (a.getAttribute('aria-label') || a.getAttribute('aria-labelledby') || a.getAttribute('title')) return true;
    if ((a.textContent || '').trim()) return true;
    var els = a.querySelectorAll('img[alt], [aria-label], svg title');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var v = el.tagName.toLowerCase() === 'title' ? el.textContent : (el.getAttribute('alt') || el.getAttribute('aria-label'));
      if (v && v.trim()) return true;
    }
    return false;
  }

  function nameLink(a) {
    if (a.getAttribute('aria-hidden') === 'true' || hasName(a)) return;
    var label = labelFromHref(a.getAttribute('href') || '');
    if (label) a.setAttribute('aria-label', label);
  }

  function patch(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.tagName === 'IFRAME') titleFrame(root);
    if (root.tagName === 'A' && root.hasAttribute('href')) nameLink(root);
    var frames = root.querySelectorAll('iframe:not([title])');
    for (var i = 0; i < frames.length; i++) titleFrame(frames[i]);
    var links = root.querySelectorAll('a[href]:not([aria-label]):not([aria-labelledby]):not([title])');
    for (var j = 0; j < links.length; j++) nameLink(links[j]);
  }

  function start() {
    patch(document.body);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) patch(added[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
